export default "20260408.1 \r\n"